module.exports = __webpack_public_path__ + "img/medicamento-favorito.fb53b853.jpg";